import { Routes } from '@angular/router';
import { CancelInterviewComponent } from './cancel-interview.component';

export const CancelInterviewRoutes: Routes = [
    {
        path: 'cancel-interview/',
        component: CancelInterviewComponent,
        data: { title: 'CANCEL_INTERVIEW.HEADER'}
    }
];
